import React from 'react';
import { Card, CardContent, Typography, CardHeader, Button, CardActions, Tooltip, Box, Grid2 } from '@mui/material';
import CalendarWithDate from '../CommonComponents/CalenderWithDate';
import { Booking, BookingType } from '../../Types/UnitFeatureTypes';
import { useNavigate } from 'react-router-dom';

const DisplayBookingCard: React.FC<{ item: Booking }> = ({ item }) => {

    const navigate = useNavigate();

    const handleReschedule = () => {        
        navigate(`/createBookingCalender`, { state: { reschedule: true, amenity: item.amenity.id, bookingDate: new Date(item.booking_start), bookingTime: item.slots } });
    }

    const isInPast = new Date(item.booking_end) < new Date();

    return (
        <Card sx={{ maxWidth: 240, minHeight: 425, borderRadius: 3, display: 'flex', justifyContent: 'space-between', flexDirection: 'column', backgroundColor: isInPast ? 'lightgrey' : '' }}>
            <Tooltip title={item.amenity.title}>
                <CardHeader title={item.amenity.title} sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} />
            </Tooltip>
            <CardContent>
                <Tooltip title={item.amenity.description}>
                    <Typography variant="h6" color="textSecondary" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' }}>
                        {item.amenity.description}
                    </Typography>
                </Tooltip>
            </CardContent> 
            <CardContent sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', verticalAlign: 'top' }}>
                <CalendarWithDate 
                    start={new Date(item.booking_start)}
                    end={new Date(item.booking_end ? item.booking_end : item.booking_start)}
                />

                {item.type === BookingType.SINGLE_SLOT && <Typography variant="subtitle1" color="textSecondary" sx={{marginTop: 2}}>
                    Booked slots
                </Typography>}
                {item.slots && <Grid2 container spacing={1} justifyContent={'space-between'}>
                    {item.slots.map(slot => (
                        <Grid2 key={slot.toString()} size={{xs: 6, sm: 4, md: 4}}>
                            <Button variant="outlined" disabled={new Date(slot) < new Date()}>
                                {new Date(slot).toLocaleTimeString('default', { hour: '2-digit', minute: '2-digit', hour12: false })}
                            </Button>
                        </Grid2>

                    ))}
                </Grid2>}

            </CardContent>
            {!isInPast && <CardActions sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <Button variant="contained" color="primary" onClick={handleReschedule}>
                    Reschedule
                </Button>
                <Button variant="contained" color="secondary" sx={{
                    '&:hover': {
                        backgroundColor: 'red'
                    }
                }}>
                    Cancel
                </Button>
            </CardActions>}
        </Card>
    );
}

export default DisplayBookingCard;